import { ChevronSvg } from './chevron';

export const PreviousChunkArrowHtml = () => `
    <div class="previous-chunk-arrow">${ChevronSvg}</div>
`;
